import flowRight from 'lodash/flowRight';
import { connect } from 'react-redux';

import { withMainControls } from '@eventbrite/eds-structure';
import { addMainControls } from '@eventbrite/eds-structure';

import Page from '../pages/Page';

const _mapStateToProps = ({ isLoading }) => ({
    isLoading,
});

const enhance = flowRight(
    connect(_mapStateToProps),
    addMainControls,
    withMainControls,
);

export default enhance(Page);
